export default class ValidatorIsEqual {
  constructor (evaluator) {
    this.errorName = 'evaluate';
    this.evaluator = evaluator;
  }

  isValid (value) {
    return this.evaluator(value);
  }
}



// WEBPACK FOOTER //
// ./utils/form-helpers/validators/validator-is-equal.js